import api from './client';

const BASE = '/api/tax-rates';

export async function fetchTaxRates(params = {}, config = {}) {
  const { data } = await api.get(BASE, { params, ...config });
  return Array.isArray(data) ? data : [];
}

export async function createTaxRate(payload, config = {}) {
  const { data } = await api.post(BASE, payload, config);
  return data;
}

export async function updateTaxRate(id, payload, config = {}) {
  const { data } = await api.put(`${BASE}/${id}`, payload, config);
  return data;
}

export async function deleteTaxRate(id, config = {}) {
  await api.delete(`${BASE}/${id}`, config);
}
